(() => {
  if (window.flowCartExperienceReady) return;
  window.flowCartExperienceReady = true;
  const hosts = new Map();
  let scheduled = false;
  const isCartActive = () => document.body.classList.contains('minicart') ||
    document.body.classList.contains('template-cart') ||
    Boolean(document.querySelector('drawer-component.mini-cart.open'));
  const syncHost = (host, state) => {
    const floating = host.shadowRoot?.querySelector('#app-embed[data-layout="floating"]');
    const suppress = Boolean(floating && isCartActive());
    if (floating && state.floating !== floating) {
      state.floating = floating;
      state.inert = floating.inert;
    }
    if (host.hasAttribute('data-flow-cart-suppressed') !== suppress) {
      host.toggleAttribute('data-flow-cart-suppressed', suppress);
    }
    if (suppress) {
      if (!floating.inert) floating.inert = true;
    } else if (state.floating && state.floating.inert !== state.inert) {
      state.floating.inert = state.inert;
    }
  };
  const sync = () => {
    scheduled = false;
    hosts.forEach((state, host) => {
      if (!host.isConnected) {
        state.observer?.disconnect();
        hosts.delete(host);
        return;
      }
      syncHost(host, state);
    });
  };
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(sync);
  };
  const bind = host => {
    if (hosts.has(host) || !host.shadowRoot) return;
    const state = { floating: null, inert: false, observer: null };
    const style = document.createElement('style');
    style.dataset.flowCartFormsGuard = 'true';
    style.textContent = ':host([data-flow-cart-suppressed]) #app-embed[data-layout="floating"]{visibility:hidden!important;pointer-events:none!important}';
    host.shadowRoot.append(style);
    hosts.set(host, state);
    state.observer = new MutationObserver(schedule);
    state.observer.observe(host.shadowRoot, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-layout', 'data-current-step']
    });
    syncHost(host, state);
  };
  const attach = host => {
    bind(host);
    if (!host.shadowRoot && window.customElements) {
      window.customElements.whenDefined('shopify-forms-embed').then(() => bind(host));
    }
  };
  const discover = root => {
    root.querySelectorAll('shopify-forms-embed').forEach(attach);
  };
  discover(document);
  new MutationObserver(records => {
    records.forEach(record => {
      record.addedNodes.forEach(node => {
        if (node.nodeType !== 1) return;
        if (node.matches('shopify-forms-embed')) attach(node);
        discover(node);
      });
    });
    schedule();
  }).observe(document.body, { childList: true, subtree: true });
  new MutationObserver(schedule).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  document.querySelectorAll('drawer-component.mini-cart').forEach(drawer => {
    new MutationObserver(schedule).observe(drawer, { attributes: true, attributeFilter: ['class', 'hidden'] });
  });
})();

/* FlowFlow – synchronise le code promo dans le panier (ajout Claude, 19/10/2026).
   Si le visiteur a un code (cookie discount_code posé par /discount/CODE, pop-up newsletter, lien e-mail…)
   mais que ce code n'est pas encore attaché au panier (navigateur intégré Instagram à la 1re visite),
   on l'ajoute via /cart/update.js puis on rafraîchit le mini-panier. Générique : PRIVATE25, WELCOME10, etc. */
(() => {
  if (window.flowDiscountSyncReady) return;
  window.flowDiscountSyncReady = true;

  const ls = (k) => { try { return localStorage.getItem(k); } catch (e) { return null; } };
  const ssGet = (k) => { try { return sessionStorage.getItem(k); } catch (e) { return null; } };
  const ssSet = (k, v) => { try { sessionStorage.setItem(k, v); } catch (e) {} };

  const cookieCodes = () => {
    const c = document.cookie.split('; ').find((x) => x.indexOf('discount_code=') === 0);
    if (!c) return [];
    return decodeURIComponent(c.slice(14)).split(',').map((s) => s.trim().toUpperCase()).filter(Boolean);
  };

  // Code de la pop-up newsletter, seulement si la personne s'est inscrite avec l'offre actuellement en cours.
  const popupCode = () => {
    const el = document.querySelector('flowdays-popup');
    if (!el || ls('flowdays-subscribed') !== '1') return null;
    const ends = Date.parse(el.dataset.ends || '');
    const saleOver = Boolean(ends && Date.now() > ends);
    const current = String(el.dataset.activeCode || (saleOver ? el.dataset.welcomeCode : el.dataset.code) || '').toUpperCase();
    const own = String(ls('flow-newsletter-code') || el.dataset.code || '').toUpperCase();
    return current && own === current ? current : null;
  };

  let busy = false;
  let timer = null;

  const run = async () => {
    if (busy) return;
    const wanted = new Set(cookieCodes());
    const p = popupCode();
    if (p) wanted.add(p);
    if (!wanted.size) return;
    busy = true;
    try {
      const cart = await (await fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })).json();
      if (!cart || !cart.item_count) return;
      const have = (cart.discount_codes || []).map((d) => String(d.code || '').toUpperCase());
      // Une seule tentative par code et par panier : pas de boucle si le code est expiré ou non cumulable.
      const missing = [...wanted].filter((c) => !have.includes(c) && ssGet('flow-dsync:' + cart.token + ':' + c) !== '1');
      if (!missing.length) return;
      missing.forEach((c) => ssSet('flow-dsync:' + cart.token + ':' + c, '1'));
      const all = [...new Set([...have, ...missing])].join(',');
      const res = await fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: all })
      });
      if (!res.ok) return;
      if (typeof window.updateMiniCart === 'function') await window.updateMiniCart(false);
    } catch (e) {
      /* silencieux : en cas d'échec, le code reste appliqué au paiement comme avant */
    } finally {
      busy = false;
    }
  };

  const later = (delay) => { clearTimeout(timer); timer = setTimeout(run, delay === undefined ? 250 : delay); };

  document.addEventListener('cart:updated', () => later());
  const init = () => {
    document.querySelectorAll('drawer-component.mini-cart').forEach((d) => {
      new MutationObserver(() => { if (d.classList.contains('open')) later(0); })
        .observe(d, { attributes: true, attributeFilter: ['class'] });
    });
    later(800);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
